import {
  PAL_INTERNAL_ACCOUNT,
  PAL_EXTERNAL_ACCOUNT,
  PAL_DEBIT_CARD,
  PAL_DISBURSE_TRANS_TYPE_ACH,
  PAL_DISBURSE_TRANS_TYPE_CORE_DC,
  P2P_DISBURSE_TRANS_TYPE_RTP,
  P2P_DISBURSE_TRANS_TYPE_FEDNOW,
  PAL_ACH,
  PAL_CORE_DC,
  P2P_RTP,
  P2P_FEDNOW,
  P2P_DDA,
  P2P_DISBURSE_TRANS_TYPE_INSTANT,
  P2P_INSTANT,
  A2A_DDA,
  A2A_INSTANT,
  A2A_DISBURSE_TRANS_TYPE_INSTANT,
  ACCOUNT_TO_ACCOUNT,
  PERSON_TO_PERSON,
} from 'consts';
import { formatCurrency } from '../../util';

const BuildDerivedId = (fundingTypeId, transactionTypeIdentifier) => {
  let derivedValue = '';

  switch (fundingTypeId) {
    case 1000:
      derivedValue = PAL_INTERNAL_ACCOUNT;
      break;
    case 2000:
      derivedValue = PAL_EXTERNAL_ACCOUNT;
      break;
    case 3000:
      derivedValue = PAL_DEBIT_CARD;
      break;
    case 4000:
      if (transactionTypeIdentifier === ACCOUNT_TO_ACCOUNT) {
        derivedValue = A2A_DDA;
      } else if (transactionTypeIdentifier === PERSON_TO_PERSON) {
        derivedValue = P2P_DDA;
      }
      break;
    default:
      break;
  }
  return derivedValue;
};

const BuildDisburseTransactionTypeIdentifierDerivedId = (
  disburseTransactionTypeIdentifier
) => {
  let derivedValue = '';

  switch (disburseTransactionTypeIdentifier) {
    case PAL_DISBURSE_TRANS_TYPE_ACH:
      derivedValue = PAL_ACH;
      break;
    case PAL_DISBURSE_TRANS_TYPE_CORE_DC:
      derivedValue = PAL_CORE_DC;
      break;
    case P2P_DISBURSE_TRANS_TYPE_RTP:
      derivedValue = P2P_RTP;
      break;
    case P2P_DISBURSE_TRANS_TYPE_INSTANT:
      derivedValue = P2P_INSTANT;
      break;
    case P2P_DISBURSE_TRANS_TYPE_FEDNOW:
      derivedValue = P2P_FEDNOW;
      break;
    case A2A_DISBURSE_TRANS_TYPE_INSTANT:
      derivedValue = A2A_INSTANT;
      break;
    default:
      break;
  }
  return derivedValue;
};

// eslint-disable-next-line import/prefer-default-export
export const addDerived = ({ ...item } = {}) => {
  item.feesAmountDerived = formatCurrency(item.feesAmount);
  item.fundingTypeDerived = BuildDerivedId(
    item.fundingTypeId,
    item.transactionTypeIdentifier
  );
  item.disburseTransactionTypeIdentifierDerived =
    BuildDisburseTransactionTypeIdentifierDerivedId(
      item.disburseTransactionTypeIdentifier
    );
  return {
    ...item,
  };
};
